import React from 'react';
import HeaderATS from './HeaderAts';
import FooterAts from './FooterAts';
import { useEffect, useState } from 'react';
import Spinner from './Spinner';
import CardStretched from './CardStretched';
import { fetchListings } from './api';
import { ChevronDownIcon } from 'lucide-react';

const Inventory = () => {
      const [posts, setPosts] = useState([]);
      const [soldVehicles, setSoldVehicles] = useState([]);
      const [loading, setLoading] = useState(true);
      const [sortOption, setSortOption] = useState('default');
      
      useEffect(() => {
        fetchListings().then((data) => {
          // Filter out listings that are marked as sold
          const availableListings = data.filter(
            listing => listing.meta_box._al_listing_listing_state !== 'Sold'
          );
          const soldListings = data.filter(
            listing => listing.meta_box._al_listing_listing_state === 'Sold'
          );
          setPosts(availableListings);
          setSoldVehicles(soldListings);
          setLoading(false);
        });
      }, []);

      // Function to handle sorting of listings
      const getSortedListings = () => {
        if (!posts.length) return [];
        
        const sortedListings = [...posts];
        
        switch (sortOption) {
          case 'price-asc':
            return sortedListings.sort((a, b) => 
              (parseInt(a.meta_box._al_listing_price) || 0) - (parseInt(b.meta_box._al_listing_price) || 0)
            );
          case 'price-desc':
            return sortedListings.sort((a, b) => 
              (parseInt(b.meta_box._al_listing_price) || 0) - (parseInt(a.meta_box._al_listing_price) || 0)
            );
          case 'year-desc':
            return sortedListings.sort((a, b) => 
              (parseInt(b.meta_box._al_listing_model_year) || 0) - (parseInt(a.meta_box._al_listing_model_year) || 0)
            );
          case 'year-asc':
            return sortedListings.sort((a, b) => 
              (parseInt(a.meta_box._al_listing_model_year) || 0) - (parseInt(b.meta_box._al_listing_model_year) || 0)
            );
          case 'mileage-asc':
            return sortedListings.sort((a, b) => 
              (parseInt(a.meta_box._al_listing_odometer) || 0) - (parseInt(b.meta_box._al_listing_odometer) || 0)
            );
          case 'mileage-desc':
            return sortedListings.sort((a, b) => 
              (parseInt(b.meta_box._al_listing_odometer) || 0) - (parseInt(a.meta_box._al_listing_odometer) || 0)
            );
          default:
            return sortedListings;
        }
      };

      const handleSortChange = (e) => {
        setSortOption(e.target.value);
      };

    return (
        <div>
            <HeaderATS />
            
            <div className='mx-full px-6 my-10 max-w-7xl mx-auto'>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
                    <h1 className='text-3xl font-bold text-gray-800'>Inventory</h1>
                    
                    {/* Sorting options */}
                    <div className="flex items-center mt-3 sm:mt-0">
                        <label htmlFor="sort-options" className="block text-sm/6 font-medium text-gray-900 mr-2 pt-2">
                            Sort by:
                        </label>
                        <div className='mt-2 grid grid-cols-1'>
                        <select 
                            id="sort-options" 
                            value={sortOption}
                            onChange={handleSortChange}
                            className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:text-sm/6"
                        >
                            <option value="default">Default</option>
                            <option value="price-asc">Price: Low to High</option>
                            <option value="price-desc">Price: High to Low</option>
                            <option value="year-desc">Year: Newest First</option>
                            <option value="year-asc">Year: Oldest First</option>
                            <option value="mileage-asc">Mileage: Lowest First</option>
                            <option value="mileage-desc">Mileage: Highest First</option>
                        </select>
                        <ChevronDownIcon
                          aria-hidden="true"
                          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                        />
                        </div>
                    </div>
                </div>
                
                <hr className='my-5' />
                <div className='flex'>
                    <div className="w-full">
                        <div className="rounded-lg dark:border-gray-700">
                            {loading
                            ? <div className='flex justify-center py-8'><Spinner /></div>
                            : posts.length !== 0
                                ?
                                <div className='my-4 py-4'>
                                    {getSortedListings().map((listing) => (
                                        <CardStretched listing={listing} key={listing.id} />
                                    ))}
                                </div>
                                :
                                <div className='my-4 py-4 flex flex-col items-center'>
                                  <p className='text-base text-gray-800'>-- No vehicles in sale inventory --</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='flex'>
                    <div className="w-full">
                        <div className="rounded-lg dark:border-gray-700">
                            {soldVehicles.length > 0 && (
                                <div className='my-4 py-4'>
                                    <h2 className='text-2xl font-bold text-gray-800'>Sold Vehicles</h2>
                                    <hr className='my-4' />
                                    {soldVehicles.map((listing) => (
                                        <CardStretched listing={listing} key={listing.id} />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <FooterAts />
        </div>
    );
};

export default Inventory;